import { AccountCreditCardActions, Badge } from '@retainerclub/common';
import { useAccount } from '@retainerclub/hooks';
import PropTypes from 'prop-types';

function BillingTableRow({ creditCard }) {
  const { accountRefetch } = useAccount();

  // Check if card expires in the next 30 days
  function isExpiringSoon() {
    const currentDate = new Date();
    // Convert 2-digit year to 4-digit year (all years are after 2000)
    const fullYear = 2000 + Number.parseInt(creditCard.expiryYear);
    // Create date for the first day of the expiry month, then set to last day
    const expiryDate = new Date(
      fullYear,
      Number.parseInt(creditCard.expiryMonth),
      0,
    );

    const thirtyDaysFromNow = new Date();
    thirtyDaysFromNow.setDate(currentDate.getDate() + 30);

    return expiryDate <= thirtyDaysFromNow && expiryDate > currentDate;
  }

  // Check if card has already expired
  function isExpired() {
    const currentDate = new Date();
    // Convert 2-digit year to 4-digit year (all years are after 2000)
    const fullYear = 2000 + Number.parseInt(creditCard.expiryYear);
    // Create date for the first day of the expiry month, then set to last day
    const expiryDate = new Date(
      fullYear,
      Number.parseInt(creditCard.expiryMonth),
      0,
    );

    return expiryDate < currentDate;
  }

  function getBrandImage(brand) {
    switch (brand) {
      case 'visa':
        return 'https://cdn.retainerclub.com/images/payment-icons/light/visa.png';
      case 'mastercard':
        return 'https://cdn.retainerclub.com/images/payment-icons/light/mastercard.png';
      case 'amex':
        return 'https://cdn.retainerclub.com/images/payment-icons/light/amex.png';
      case 'discover':
        return 'https://cdn.retainerclub.com/images/payment-icons/light/discover.png';
      default:
        return 'https://cdn.retainerclub.com/images/payment-icons/light/visa.png';
    }
  }

  return (
    <tr className="text-black">
      <td className="p-2 md:p-4">{creditCard.nameOnCard}</td>
      <td className="flex flex-col items-start justify-center gap-2 p-2 md:flex-row md:items-center md:justify-start md:p-4">
        <img
          src={getBrandImage(creditCard.brand)}
          alt={creditCard.brand}
          className="h-6 w-auto"
        />
        {creditCard.maskedNumber}
      </td>
      <td className="p-2 md:p-4">
        {creditCard.expiryMonth}/{creditCard.expiryYear}
      </td>
      <td className="flex flex-col items-start justify-center gap-2 p-2 sm:flex-row sm:items-center sm:justify-start md:p-4">
        {creditCard.defaultCard && (
          <Badge color="green" name="Default" size="small" />
        )}
        {isExpiringSoon() && (
          <Badge color="yellow" name="Expiring soon" size="small" />
        )}
        {isExpired() && <Badge color="red" name="Expired" size="small" />}
      </td>
      <td className="p-2 text-right md:p-4">
        <AccountCreditCardActions
          creditCard={creditCard}
          refetch={accountRefetch}
          isExpired={isExpired()}
        />
      </td>
    </tr>
  );
}

BillingTableRow.propTypes = {
  creditCard: PropTypes.object.isRequired,
};

export default BillingTableRow;
